import { SHEET_SECTION, STAGE } from './sheet-sections.js';
import { DESIGN_SHEET_STATUS } from '../types/design-sheet.js';
import { EDIT_SCOPE } from './edit-scopes.js';
import { canAccessKnownBrand } from './brand-scope.js';
import { PERMISSION } from './permissions.js';
import { sheetManualCommerceIssues } from './planner-style.js';
import { baselineSizesReady, sizeDeviationsReady, stageContentIssue } from './stage-content.js';
/** PDF 是当前可见资料的只读输出；最终确认仍由原编辑域单独控制。 */
export function canExportTechpack(permissions, brands, brandCd) {
    return permissions.includes(PERMISSION.SHEET_VIEW) && canAccessKnownBrand(brands, brandCd);
}
export const TECHPACK_PREREQUISITES = [
    { section: SHEET_SECTION.MATERIAL, stage: STAGE.PURCHASE_DONE },
    { section: SHEET_SECTION.MATERIAL, stage: STAGE.PRODUCTION_REVIEWED },
    { section: SHEET_SECTION.MATERIAL, stage: STAGE.TRIM_TECHNICAL_DONE },
    { section: SHEET_SECTION.MATERIAL, stage: STAGE.USAGE_ENTERED },
    { section: SHEET_SECTION.PATTERN, stage: STAGE.BASE_SIZE_DONE },
    { section: SHEET_SECTION.PATTERN, stage: STAGE.SIZE_SPEC_DONE },
];
/** 最低内容检查：空表、纯空行不能被完成标记伪装成尺寸已就绪。0 是合法值。 */
export function hasPatternSizeContent(rows) {
    const hasNumber = (value) => value !== null && value.trim() !== '' && Number.isFinite(Number(value));
    return rows.some((row) => Boolean(row.patternPartCd?.trim() || row.patternPartNm?.trim())
        && (hasNumber(row.size) || row.values.some((v) => hasNumber(v.value))));
}
export function techpackReadiness(sheet) {
    const hasSizes = baselineSizesReady(sheet.stdSizes);
    return {
        designApproved: sheet.status === DESIGN_SHEET_STATUS.APPROVED,
        missing: TECHPACK_PREREQUISITES.filter((p) => (p.section === SHEET_SECTION.PATTERN && !hasSizes)
            || (p.stage === STAGE.SIZE_SPEC_DONE && !sizeDeviationsReady(sheet.stdSizes))
            || (p.section === SHEET_SECTION.MATERIAL && sheet.materials && sheet.subMaterials && stageContentIssue(p.section, p.stage, sheet))
            || !sheet.sectionStages.some((s) => s.section === p.section && s.stage === p.stage && s.completed)),
    };
}
export function isTechpackConfirmed(sheet) {
    const readiness = techpackReadiness(sheet);
    return readiness.designApproved && readiness.missing.length === 0
        && (sheet.source !== 'MANUAL' || sheetManualCommerceIssues({ source: 'MANUAL', plannerOrderEditable: sheet.plannerOrderEditable, matrixColors: sheet.matrixColors ?? [], matrixSizes: sheet.matrixSizes ?? [], orderQuantities: sheet.orderQuantities ?? [], salePrice: sheet.salePrice ?? null, receivingDueDate: sheet.receivingDueDate ?? null }).length === 0)
        && sheet.sectionStages.some((s) => s.section === SHEET_SECTION.TECHPACK && s.stage === STAGE.STEP_DONE && s.completed);
}
export function affectsTechpack(scope) {
    const unaffected = [EDIT_SCOPE.TECHPACK_EXPORT, EDIT_SCOPE.QC, EDIT_SCOPE.ONLINE, EDIT_SCOPE.COST];
    return !unaffected.includes(scope);
}
//# sourceMappingURL=techpack-readiness.js.map